// Shared button. `variant` maps to the classes defined in ui.css.
export default function Button({ variant = '', small, children, ...rest }) {
  const cls = ['btn', variant, small ? 'small' : ''].filter(Boolean).join(' ');
  return (
    <button className={cls} {...rest}>
      {children}
    </button>
  );
}
